module.exports = __webpack_public_path__ + "img/floor_type21.b567bc07.png";